// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Maintenance_date__2l8SI {\n  font-size: 18px;\n  margin-top: 20px;\n  font-weight: bold;\n  color: var(--color-bar);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Navigation/Maintenance.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB","sourcesContent":[".date {\n  font-size: 18px;\n  margin-top: 20px;\n  font-weight: bold;\n  color: var(--color-bar);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"date": "Maintenance_date__2l8SI"
};
export default ___CSS_LOADER_EXPORT___;
